import { useCallback } from 'react'

import { AIChatLauncherPosition } from '../../../types/graphql'
import { Select } from '../../govwell-ui'
import { SelectOption } from '../../govwell-ui/components/Select/types'

const options: SelectOption<AIChatLauncherPosition>[] = [
  {
    label: 'Bottom left',
    value: 'BottomLeft',
  },
  {
    label: 'Bottom right',
    value: 'BottomRight',
  },
]

type Props = {
  label: React.ReactNode
  onValueChange: (value: AIChatLauncherPosition) => void
  value: AIChatLauncherPosition | null | undefined
}
const AIChatBotPositionSelect = ({ label, onValueChange, value }: Props) => {
  const handleSelectedOptionChange = useCallback(
    (option: SelectOption<AIChatLauncherPosition> | undefined) => {
      if (!option) {
        return
      }
      onValueChange(option.value)
    },
    [onValueChange]
  )

  const getOptionKey = useCallback((o: SelectOption<AIChatLauncherPosition>) => {
    return o.value
  }, [])

  return (
    <Select
      getOptionKey={getOptionKey}
      label={label}
      onSelectedOptionChange={handleSelectedOptionChange}
      options={options}
      selectedOption={options.find((o) => o.value === value)}
    />
  )
}

export default React.memo(AIChatBotPositionSelect)
